// Where the backend lives — decided once, here.
//
// Until now every module carried its own `http://192.168.1.162:5000`, 83 of them
// across 66 files. That works on the factory network and nowhere else: from a
// phone outside the building those requests aim at a private address that does
// not exist, and over HTTPS the browser blocks them as mixed content before
// they are even attempted.
//
// Two situations, one rule:
//
//   · on the factory network the app talks to each service on its own port,
//     exactly as it always has
//   · through the Cloudflare tunnel everything arrives on ONE hostname and is
//     routed by path prefix (/api/v1, /api/redis, /api/influx, /socket.io), so
//     the correct base is the empty string — a relative URL, same origin
//
// The LAN hosts are the enumerated case and everything else is assumed to be
// the tunnel. That direction matters: a new public hostname then needs no code
// change, and the failure mode for an unrecognised host is "same origin", which
// is what the tunnel wants. The reverse default would send a stranger's browser
// looking for 192.168.1.162.

const LAN_IP = '192.168.1.162';

// `localhost` and `127.0.0.1` cover running the dev server on the machine
// itself; LAN_IP covers every other client inside the building.
const LAN_HOSTS = [LAN_IP, 'localhost', '127.0.0.1'];

// `typeof window` guards the jest/node environment, where there is no location
// and the LAN answer is the harmless one.
const onLan =
  typeof window === 'undefined' || LAN_HOSTS.includes(window.location.hostname);

const lan = port => `http://${LAN_IP}:${port}`;

const sameOrigin = () =>
  typeof window === 'undefined' ? '' : window.location.origin;

export const API = {
  /** eng-backend — standards, orders, products, users, warehouse. */
  BACKEND: onLan ? lan(5000) : '',

  /** redis_dev — jobs, queues, dashboards, labels. */
  REDIS: onLan ? lan(5100) : '',

  /** refactor_machine_traking — InfluxDB graphs, alarms, machine state. */
  MACHINE: onLan ? lan(5001) : '',

  /**
   * Socket.IO. Unlike the others this cannot be the empty string — socket.io
   * needs an absolute origin — so through the tunnel it is the page's own,
   * where cloudflared routes /socket.io/ to the websocket listener.
   */
  WS: onLan ? lan(8080) : sameOrigin(),

  /**
   * The app's own address, for QR codes that a phone will open. On the LAN it
   * stays the dev-server URL that has always been printed; through the tunnel
   * it is the public origin, which is the only thing a phone outside the
   * building could follow.
   */
  APP: onLan ? lan(3000) : sameOrigin(),
};

// Kept under its original name: ~29 modules already import it this way, and
// the environment override is still honoured.
export const INFLUX_API = process.env.REACT_APP_INFLUX_API || API.MACHINE;
